import { createWebHistory, createRouter } from "vue-router"
import i18n from '@/i18n'
import { useCookies } from '@vueuse/integrations/useCookies'

import routes from '@/Libs/Route/Index';
import store from "@/Libs/Store.js";

var router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0, left: 0 };
    }
  },
});

router.beforeEach(async (routeTo, routeFrom, next) => {
  const cookies = useCookies()
  const api_token = cookies.get('api_token')
  const is_login = api_token !== undefined && api_token !== null && api_token !== ""

  const requiredAccess = routeTo.meta.permission;

  if (routeTo.name === 'employee-invite') {
    return next()
  }

  if (routeTo.name === 'verify-email' || routeTo.name === 'verify-session') {
    if (!is_login) {
      return next({
        name: 'login',
        query: { redirectFrom: routeTo.fullPath }
      })
    }
    return next()
  }

  if (is_login && !requiredAccess) {
    return next({ path: '/' })
  }

  if (!requiredAccess) return next();

  if (!is_login) {
    return next({ name: 'login', query: { redirectFrom: routeTo.fullPath } })
  }

  var permissions = store.state.accessControl.user.permission;
  if (Array.isArray(permissions)) {
    var hasAccess = permissions.includes(requiredAccess);

    if (!hasAccess)
      return next({ name: 'unauthorized' });
  }
  next()
});

const APP_NAME = process.env.VUE_APP_NAME

router.afterEach((to) => {
  const title = to.meta.title
    ? i18n.global.t(to.meta.title)
    : ''

  document.title = title
    ? `${title} | ${APP_NAME}`
    : APP_NAME
})

export default router;
